/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type FishbrainExportStartResponse,
    FishbrainExportStartResponseFromJSON,
    FishbrainExportStartResponseToJSON,
} from '../models/FishbrainExportStartResponse';
import {
    type FishbrainExportStatusRequest,
    FishbrainExportStatusRequestFromJSON,
    FishbrainExportStatusRequestToJSON,
} from '../models/FishbrainExportStatusRequest';
import {
    type FishbrainExportStatusResponse,
    FishbrainExportStatusResponseFromJSON,
    FishbrainExportStatusResponseToJSON,
} from '../models/FishbrainExportStatusResponse';
import {
    type FishbrainLoginRequest,
    FishbrainLoginRequestFromJSON,
    FishbrainLoginRequestToJSON,
} from '../models/FishbrainLoginRequest';
import {
    type FishbrainLoginResponse,
    FishbrainLoginResponseFromJSON,
    FishbrainLoginResponseToJSON,
} from '../models/FishbrainLoginResponse';
import {
    type HTTPValidationError,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/HTTPValidationError';

export interface FishbrainExportStartRequest {
    /**
     * 
     */
    accessToken?: string | null;
}

export interface FishbrainExportStatusOperationRequest {
    /**
     * 
     */
    fishbrainExportStatusRequest: FishbrainExportStatusRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface FishbrainLoginOperationRequest {
    /**
     * 
     */
    fishbrainLoginRequest: FishbrainLoginRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

/**
 * 
 */
export class FishbrainApi extends runtime.BaseAPI {

    /**
     * Creates request options for fishbrainExportStart without sending the request
     */
    async fishbrainExportStartRequestOpts(requestParameters: FishbrainExportStartRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/fishbrain/export/start`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fishbrain Export Start
     */
    async fishbrainExportStartRaw(requestParameters: FishbrainExportStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FishbrainExportStartResponse>> {
        const requestOptions = await this.fishbrainExportStartRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FishbrainExportStartResponseFromJSON(jsonValue));
    }

    /**
     * Fishbrain Export Start
     */
    async fishbrainExportStart(requestParameters: FishbrainExportStartRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FishbrainExportStartResponse> {
        const response = await this.fishbrainExportStartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for fishbrainExportStatus without sending the request
     */
    async fishbrainExportStatusRequestOpts(requestParameters: FishbrainExportStatusOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['fishbrainExportStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'fishbrainExportStatusRequest',
                'Required parameter "fishbrainExportStatusRequest" was null or undefined when calling fishbrainExportStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/fishbrain/export/status`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FishbrainExportStatusRequestToJSON(requestParameters['fishbrainExportStatusRequest']),
        };
    }

    /**
     * Fishbrain Export Status
     */
    async fishbrainExportStatusRaw(requestParameters: FishbrainExportStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FishbrainExportStatusResponse>> {
        const requestOptions = await this.fishbrainExportStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FishbrainExportStatusResponseFromJSON(jsonValue));
    }

    /**
     * Fishbrain Export Status
     */
    async fishbrainExportStatus(requestParameters: FishbrainExportStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FishbrainExportStatusResponse> {
        const response = await this.fishbrainExportStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for fishbrainLogin without sending the request
     */
    async fishbrainLoginRequestOpts(requestParameters: FishbrainLoginOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['fishbrainLoginRequest'] == null) {
            throw new runtime.RequiredError(
                'fishbrainLoginRequest',
                'Required parameter "fishbrainLoginRequest" was null or undefined when calling fishbrainLogin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/fishbrain/login`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FishbrainLoginRequestToJSON(requestParameters['fishbrainLoginRequest']),
        };
    }

    /**
     * Fishbrain Login
     */
    async fishbrainLoginRaw(requestParameters: FishbrainLoginOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FishbrainLoginResponse>> {
        const requestOptions = await this.fishbrainLoginRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FishbrainLoginResponseFromJSON(jsonValue));
    }

    /**
     * Fishbrain Login
     */
    async fishbrainLogin(requestParameters: FishbrainLoginOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FishbrainLoginResponse> {
        const response = await this.fishbrainLoginRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
